import React from "react";
import { Box, Typography, Container, Paper } from "@mui/material";

const About: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          About This Project
        </Typography>
        <Typography variant="body1" paragraph>
          This application provides information about school vaccination rates
          across California. Our goal is to make vaccination data accessible and
          transparent for parents, educators, and community members.
        </Typography>
        <Typography variant="body1" paragraph>
          The data presented here is sourced from the California Department of
          Public Health.
        </Typography>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            Credits
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>Reporting:</strong> Karen D’Souza
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>Projects Editor:</strong> Adam Eisenberg
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>Data Analysis:</strong> Daniel J. Willis
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>Website design and development:</strong> Yuxuan (Sunny) Xie
            and Justin Allen
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>Map design:</strong> Yuxuan (Sunny) Xie
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>Copy editing:</strong> Chuck Carroll
          </Typography>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom>
            Data Notes
          </Typography>
          <Typography variant="body1" paragraph>
            The California Department of Public Health hides small numbers of
            students to protect the privacy of students. Schools with fewer than
            20 students in Transitional Kindergarten and Kindergarten are
            excluded from the data entirely, schools with 20-49 enrollees are
            listed at 95% even if the actual percentage is higher, schools with
            50-99 enrollees are capped at 98%, and schools with 100 or more
            students are capped at 99%. Assume any school with one of those
            three totals is greater than what you see. All data is self-reported
            by schools or districts to CDPH. If you believe the rate at your or
            your child's school is incorrect please contact the school with
            questions. If you're a school employee and believe your school's
            number is incorrect please contact CDPH to have it fixed in the
            official records.
          </Typography>
        </Box>

        <Typography variant="body1" sx={{ mt: 4 }}>
          For questions or feedback, please contact us at edsource@edsource.org.
        </Typography>
      </Paper>
    </Container>
  );
};

export default About;
